import { Grading, Replay } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PersonReadDTO } from '../api/dto';

interface SelectablePersonListControlsProps {
    persons: PersonReadDTO[];
    selection: Set<number>;
    disabled?: boolean;
    setSelected: (values: Set<number>) => void;
    otherActions?: React.ReactNode;
}

export const SelectablePersonListControls: React.FC<SelectablePersonListControlsProps> = ({
    persons,
    selection,
    disabled,
    setSelected,
    otherActions,
}) => {
    const intl = useIntl();
    const personsSet = useMemo(() => new Set(persons.map((a) => a.id)), [persons]);
    const setAllSelected = () => setSelected(new Set(personsSet));
    const setNoneSelected = () => setSelected(new Set());
    return selection.size > 0 ? (
        <Stack direction="row" spacing={1} justifyContent="space-between">
            <Stack direction="row">{otherActions}</Stack>
            <Stack direction="row" justifyContent="flex-end">
                <Tooltip title={intl.formatMessage({ id: 'common.selectAll' })}>
                    <span>
                        <IconButton disabled={selection.size === personsSet.size || disabled} onClick={setAllSelected}>
                            <Grading />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={intl.formatMessage({ id: 'common.reset' })}>
                    <span>
                        <IconButton onClick={setNoneSelected} disabled={disabled}>
                            <Replay />
                        </IconButton>
                    </span>
                </Tooltip>
            </Stack>
        </Stack>
    ) : null;
};
